import { render, staticRenderFns } from "./AskBillTable.vue?vue&type=template&id=48c6b464&"
import script from "./AskBillTable.vue?vue&type=script&lang=js&"
export * from "./AskBillTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports